import React, { useState, useEffect } from 'react';

import { db } from '../firebase';
import Layout from '../components/Layout';
import TableBills from '../components/tables/bills';
import { Grid } from '@material-ui/core';

import moment from 'moment';
import 'moment/locale/th';
moment().locale('th');

const Bills = () => {
  const [bills, setBills] = useState([]);

  useEffect(() => {
    const getBills = async () => {
      const snapshot = await db
        .collection('billings')
        .orderBy('dateCreated', 'desc')
        .get();
      const data = snapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      setBills(data);
    };
    getBills();
  }, []);

  return (
    <Layout>
      <Grid container spacing={2} style={{ justifyContent: 'center' }}>
        <Grid item sm={6} md={4}>
          {bills.length > 0 && <TableBills data={bills} />}
        </Grid>
      </Grid>
    </Layout>
  );
};

export default Bills;
